'use client';

import { useState } from 'react';

import useNewsLetterService from '@/hooks/useNewsLetter';
import { useTranslation } from '@/lib/i18n';

import Button from './Button';
import { Input } from './Input';

type NewsLetterProps = {
  className?: string;
};

const NewsLetter = ({ className }: NewsLetterProps) => {
  const { t } = useTranslation();
  const newsLetterSvc = useNewsLetterService();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      setMessage(t('footer.invalidEmail'));
      return;
    }
    setLoading(true);
    setMessage('');
    try {
      await newsLetterSvc.subscribe(email);
      setMessage(t('footer.subscribeSuccess'));
      setEmail('');
    } catch (error) {
      setMessage(t('footer.subscribeError'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`md:py-4 p-0 rounded-md ${className}`}>
      <h2 className="text-lg font-semibold mb-2">Suscríbete</h2>
      <p className="mb-4 text-xs">{t('footer.newsletterDescription')}</p>
      <form onSubmit={handleSubmit} className="py-theme-md flex flex-row gap-3 justify-between items-center">
        <div className="flex-1">
          <Input type="email" placeholder={t('footer.emailPlaceholder')} value={email} onChange={(e) => setEmail(e.target.value)} fullWidth className="p-2 border-2 rounded" required />
        </div>
        <Button fullWidth type="submit" disabled={loading} size="md" data-testid="newsletter-submit" className="bg-theme-primary p-2 px-5 rounded-theme-full font-bold text-white hover:bg-theme-primary-hover transition">
          {loading ? 'Suscribiendo...' : 'Suscribirse'}
        </Button>
      </form>
      {message && <p className="mt-2 text-sm">{message}</p>}
    </div>
  );
};

export default NewsLetter;
